// SPDX-License-Identifier: Apache-2.0
import LayerWmts from './layerwmts';

/*
 * This class is a used in the state of the application, which will be accessed behind a javascript proxy.
 * This means that each modification made to its properties must come from outside,
 * because they have to be made through the proxy, so that the modification can be listen.
 * Therefore, this class must not contain any method which is updating a value directly
 * For example, any method doing <this.xxx = value> is forbidden here, because the modification be known from the proxy
 */
export default class LayerWmtsExternal extends LayerWmts {
  private static nextAvailableLayerId = 20000000;

  private selected: boolean = false;

  public get isSelected() {
    return this.selected;
  }

  public set isSelected(value) {
    this.selected = value;
    this.isDefaultChecked = value;
  }

  public constructor(name: string, url: string, layer: string) {
    const id = LayerWmtsExternal.nextAvailableLayerId++;
    super(id, name, 0, url, layer);
  }

  public override clone(): LayerWmtsExternal {
    const clonedLayer = new LayerWmtsExternal(this.name, this.url, this.layer);
    clonedLayer.isSelected = this.isSelected;
    return clonedLayer;
  }
}
